import { createSelector } from '@reduxjs/toolkit';
import { alphaSort } from 'vet-bones/utils';
import { SelectItem } from 'vet-bones/utils/select';

import { getLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectAttributesByIriSelector } from 'src/selectors/projectAttributesByIri';
import { projectLabelsByIriSelector } from 'src/selectors/projectLabelsByIri';
import * as copy from 'src/templates/copy';

export const projectAttributeRangesByIriSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      projectAttributesByIriSelector(projectId),
      projectLabelsByIriSelector(projectId),
      (attributesByIri, labelsByIri) =>
        Object.values(attributesByIri).reduce<Record<string, SelectItem[]>>(
          (acc, { value, ranges }) => {
            acc[value] = Object.keys(ranges)
              .map((range) => ({
                text: getLabelForIri(
                  labelsByIri,
                  range,
                  copy.components.projectDiagram.modelConceptClass.new
                ),
                value: range,
              }))
              .sort(alphaSort((item) => item.text));
            return acc;
          },
          {}
        )
    )
);
